/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { DateInfoVO } from './DateInfoVO';
import { NameInfoVO } from './NameInfoVO';

export interface SecureFlightPassengerInfoVO {
  birthDate?: DateInfoVO;
  canadaTravelerNumber?: string;
  /**
   * gender
   */
  gender?: string;
  /**
   * Known traveler number
   */
  knownTravelerNumber?: string;
  name?: NameInfoVO;
  /**
   * Redress number
   */
  redressNumber?: string;
}
